// function megaMenuListener() {
//     const megaMenuList = document.querySelectorAll('.mega-menu__content');
//     megaMenuList.forEach(megaMenu => {
//         megaMenu.addEventListener('mouseout', (e) => {
//             if (e.relatedTarget.closest('.mega-menu__content')) return;
//             const parentMegaMenu = e.target.closest('.mega-menu');
//             parentMegaMenu.removeAttribute('open');

//         });
//     })
// }

// document.addEventListener('DOMContentLoaded', () => {
//     megaMenuListener();
// })

document.querySelectorAll('nav.header__inline-menu .list-menu > li').forEach(item => {
    const megaMenu = item.querySelector('.mega-menu'); // Busca o elemento details dentro do item
  
    if (megaMenu) {
      item.addEventListener('mouseenter', () => {
        megaMenu.setAttribute('open', '');
      });
  
      item.addEventListener('mouseleave', () => {
        megaMenu.removeAttribute('open'); 
      });
    }
  });
  